import { FC, useRef } from 'react'
import { createPortal } from 'react-dom'
import { ReactComponent as ModalClose } from 'src/assets/svg/modal-close.svg'
import { ReactComponent as CopyIcon } from 'src/assets/svg/copy-icon-black.svg'
import { ReactComponent as DiagonalArrowUp } from 'src/assets/svg/diagonalArrowUp-black.svg'
import { ReactComponent as MailIcon } from 'src/assets/svg/Mail.svg'
import { useDisableScroll } from 'src/hooks/useDisableScroll'
import useOutsideClick from 'src/hooks/useOutsideClick'
import classes from './upgradePlanModal.module.scss'

interface UpgradePlanModalProps {
  description?: string
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  title?: string
}

export const UpgradePlanModal: FC<UpgradePlanModalProps> = ({
  isOpen,
  setIsOpen,
  title = 'Upgrade Plan',
  description = 'This feature is available as an add-on. Please reach out to the Hapttic support team to upgrade your plan and enable it.',
}) => {
  const ref = useRef<HTMLDivElement>(null)

  useOutsideClick({
    onOutsideClick: () => setIsOpen(false),
    ref,
  })

  useDisableScroll(isOpen)

  if (!isOpen) return null

  const handleContactSupport = () => {
    window.location.href = 'mailto:hello@hapttic.com'
  }

  const handleCopyEmail = () => {
    navigator.clipboard.writeText('hello@hapttic.com')
  }

  const handleCopyPhone = () => {
    navigator.clipboard.writeText('+995 599 888 955')
  }

  return createPortal(
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent} ref={ref}>
        <div className={classes.modalHeader}>
          <h2 className={classes.modalTitle}>{title}</h2>
          <button
            className={classes.closeButton}
            onClick={() => setIsOpen(false)}
            type="button"
          >
            <ModalClose />
          </button>
        </div>

        <div className={classes.modalBody}>
          <p className={classes.description}>{description}</p>

          <div className={classes.contactInfo}>
            <div className={classes.contactItemWrapper}>
              <a
                className={classes.contactItem}
                href="mailto:hello@hapttic.com"
              >
                <MailIcon className={classes.mailIcon} />
                <span className={classes.contactText}>hello@hapttic.com</span>
                <DiagonalArrowUp className={classes.linkIcon} />
              </a>
              <button
                className={classes.copyButton}
                onClick={handleCopyEmail}
                type="button"
              >
                <CopyIcon className={classes.copyIcon} />
              </button>
            </div>

            <div className={classes.contactItemWrapper}>
              <div className={classes.contactItem}>
                <span className={classes.phoneIcon}>📞</span>
                <span className={classes.contactText}>+995 599 888 955</span>
              </div>
              <button
                className={classes.copyButton}
                onClick={handleCopyPhone}
                type="button"
              >
                <CopyIcon className={classes.copyIcon} />
              </button>
            </div>
          </div>
        </div>

        <div className={classes.modalFooter}>
          <button
            className={classes.discardButton}
            onClick={() => setIsOpen(false)}
            type="button"
          >
            Discard
          </button>
          <button
            className={classes.contactButton}
            onClick={handleContactSupport}
            type="button"
          >
            Contact Support
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}
